import axios from '../plugins/axios'

export default {
  //************************
  //GLOBAL
  //************************
  getPrivateParams (){
    
    //console.log("THS", process.$session);
    // let p = JSON.parse(localStorage.getItem('persistent'))
    let p =  process.$session
    return {
      account: p.account.name,
      token: p.token,
      user_id: p.id
    }
  },
  API_GET_PAYMETHODS(direction) {
    if(direction=='deposit'){
      direction = '/';
    }else{
      direction = '/withdraw';
    }
  
    return new Promise((resolve, reject) => {
      axios.get('payments'+direction+'?uid='+process.$session.account.name)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    })
  },
  API_GET_BTCRATE() {
    return new Promise((resolve, reject) => {
      axios.get('bitstamp')
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    })
  },
  BTC_DEPOSIT() {

    return new Promise((resolve, reject) => {
      axios.post('deposit/btc', this.getPrivateParams())
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  TRC20_DEPOSIT() {
    return new Promise((resolve, reject) => {
      axios.post('deposit/trc20', this.getPrivateParams())
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  ERC20_DEPOSIT() {
    return new Promise((resolve, reject) => {
      axios.post('deposit/erc20', this.getPrivateParams())
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  ZEBRA_DEPOSIT(amount) {
    let params = this.getPrivateParams()
    params.amount = amount
    return new Promise((resolve, reject) => {
      axios.post('deposit/zebrapay', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  PAYOSTAR_DEPOSIT(amount) {
    let params = this.getPrivateParams()
    params.amount = amount
    return new Promise((resolve, reject) => {
      axios.post('deposit/payostar', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  WEBMONEY_DEPOSIT() {
    let params = this.getPrivateParams()
    params.subtype = 'tx'
    return new Promise((resolve, reject) => {
      axios.post('deposit/webmoney', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  ZEBRA_WITHDRAW(wallet,amount, sms) {

    let params = this.getPrivateParams()
    params.wallet = wallet
    params.amount = amount

    if(sms){
      params.sms_notif = 'on'
      params.notif_phone = sms 
    }else{
      params.notif_phone = ''
    }

    return new Promise((resolve, reject) => {

      axios.post('withdraw/zebrapay', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  WEBMONEY_WITHDRAW (wallet, amount, sms) {

    let params = this.getPrivateParams()
    params.zwallet = wallet
    params.amount = amount

    if(sms){
      params.sms_notif = 'on'
      params.notif_phone = sms 
    }else{
      params.notif_phone = ''
    }

    return new Promise((resolve, reject) => {

      axios.post('withdraw/webmoney', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  },
  P2P_WITHDRAW (wallet, amount) {

    let params = this.getPrivateParams()
    params.wallet = wallet
    params.amount = amount
    return new Promise((resolve, reject) => {

      axios.post('withdraw/player2player', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  }, 
  BTC_WITHDRAW (wallet, amount, sms, commission) {

    let params = this.getPrivateParams()
    params.wallet = wallet
    params.amount = amount

    if(sms){
      params.sms_notif = 'on'
      params.notif_phone = sms 
    }else{
      params.notif_phone = ''
    }

    if(!commission){
      params.default_commission = 'on'
      params.commission = 0 
    }else{
      params.commission = commission
    }

    return new Promise((resolve, reject) => {

      axios.post('withdraw/btc', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  }, 
  TRC20_WITHDRAW (wallet, amount, sms, commission) {

    let params = this.getPrivateParams()
    params.wallet = wallet
    params.amount = amount

    if(sms){
      params.sms_notif = 'on'
      params.notif_phone = sms 
    }else{
      params.notif_phone = ''
    }
    return new Promise((resolve, reject) => {
      axios.post('withdraw/trc20', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  }, 
  ERC20_WITHDRAW (wallet, amount, sms, commission) {

    let params = this.getPrivateParams()
    params.wallet = wallet
    params.amount = amount

    if(sms){
      params.sms_notif = 'on'
      params.notif_phone = sms 
    }else{
      params.notif_phone = ''
    }
    return new Promise((resolve, reject) => {
      axios.post('withdraw/erc20', params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
        })
    });
  }, 
  ORDER_CHANGE_STATUS_TO(order_id, status) {
    let params = this.getPrivateParams() 
    params.order_id = order_id;
    params.status = status;
    return new Promise((resolve, reject) => {

     axios.post('status', params)
       .then(response => {
         resolve(response)
       })
       .catch(e => {
         reject(e)
         console.log(e)
       })
   });
  },
  PREPARE_PAYMENT(type,  method) {
    let params = this.getPrivateParams();
    return new Promise((resolve, reject) => {
      axios.post(`prepare/${type}/${method}`, params)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e) 
        })
    });
  },
  GET_HISTORY(type, status, method, num) {  

    let params = this.getPrivateParams();
    
    if(method === undefined || method === 'all') {
      method = false
    }

    if(num === undefined || num === false) {
      num = 15
    }
    if(status=='all'){
       status = 'any'
    }

    if(type!=='all'){ 
      params.type = type
    }
    if(method != false){
      params.method = method
    }
    params.status = status
    params.num = num


    return new Promise((resolve, reject) => {
      axios.get('history', {
          params: params
         })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  } 
}



// WEBPACK FOOTER //
// ./src/api/api.js